export function buildFormData(data: any, formData: FormData, previousKey: string = '') {
    for (let [key, value] of Object.entries<any>(data)) {
        if (Array.isArray(data[key])) {
            for (let i = 0; i < data[key].length; i++) {
                buildFormData(data[key], formData, `${key}[${i}]`);
            }
        } else {
            if (previousKey) {
                formData.append(`${previousKey}.${key}`, value);
            } else {
                formData.append(key, value);
            }
        }
    }
}